<template>
    <card-list-item @click="$emit('click')" :class="{'active': active}">
        <template v-slot:icon><i class="fa-fw fa-usd-square" :class="{'fas': active, 'far': !active}"></i></template>
        <template v-slot:content>
            <div class="tile-title">{{ type.title }}</div>
            <div class="meta" v-if="type.enabled_at && type.disabled_at">
                {{activeDates}}
            </div>
            <div class="meta has-text-warning" v-if="!type.is_enabled">Disabled for Registration</div>

            <div class="meta"><strong>{{ type.fee | currency }}</strong></div>
        </template>
        <template v-slot:status>
            <div class="stats">
                <span class="stat"><i class="handle fas fa-bars" style="cursor: move"></i></span>
            </div>
        </template>
    </card-list-item>
</template>

<script>
    import Toolbar from "@/TIER/components/Toolbar";
    import DataRow from "@/TIER/components/DataRow";
    import CardListItem from "@/TIER/components/CardListItem";
    import moment from "moment";

    export default {
        name: 'ConfTypeTile',
        components: {CardListItem, DataRow, Toolbar},
        props: {
            card: {
                required: true
            },
            type: {
                type: Object,
                required: true
            },
            active: {
                type: Boolean,
                default: false
            }
        },
        data: function() {
            return {};
        },
        computed: {
            activeDates: function() {
                let s = moment(this.type.enabled_at);
                let e = moment(this.type.disabled_at);
                if (s.isSame(e, 'day')) {
                    return s.format('MMM D, YYYY, h:mm a - ') + e.format('h:mm a');
                } else if (s.isSame(e, 'month')) {
                    return s.format('MMM D, h:mm a - ') + e.format('MMM D, h:mm a, YYYY');
                } else if (s.isSame(e, 'year')) {
                    return s.format('MMM D, h:mm a - ') + e.format('MMM D, h:mm a, YYYY');
                } else {
                    return s.format('MMM D, YYYY, h:mm a - ') + e.format('MMM D, YYYY, h:mm a');
                }
            }
        }
    };
</script>

<style lang="scss" scoped>
    @import '../../assets/variables';

    li {
        color: darken($t-primary, 18);
        padding: 0.5rem 0;

        .tile-title {
            font-size: .9rem;
            font-weight: 700;
        }

        .tile-details {
            margin-top: 0.5rem;
        }

        .fa-exclamation-triangle {
            color: orangered;
        }
    }
</style>
